import React, { createContext, useContext, useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { graphRequest, graphConfig } from "../authConfig";

interface UserContextType {
  displayName: string;
  email: string;
}

const UserContext = createContext<UserContextType | null>(null);

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { instance, accounts } = useMsal();
  const [user, setUser] = useState<UserContextType>({ displayName: "", email: "" });

  useEffect(() => {
    const getUserProfile = async () => {
      if (accounts.length > 0) {
        const request = { ...graphRequest, account: accounts[0] };
        const response = await instance.acquireTokenSilent(request);

        const res = await fetch(graphConfig.graphMeEndpoint, {
          headers: { Authorization: `Bearer ${response.accessToken}` },
        });
        const data = await res.json();

        setUser({
          displayName: data.displayName,
          email: data.mail || data.userPrincipalName,
        });
      }
    };

    getUserProfile();
  }, [accounts, instance]);

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};
